/**
 * ClosingCta.tsx — avsluttende CTA-felt («Take the next step»)
 */

import type { LandingLink } from '@/types/landing';
import LandingButton from './LandingButton';
import styles from './landing-sections.module.css';

export default function ClosingCta({ cta }: { cta: { heading: string; body: string; primary: LandingLink } }) {
  return (
    <section className={styles.cta} aria-labelledby="cta-heading">
      <div className={styles.container}>
        <h2 id="cta-heading" className={styles.h2}>
          {cta.heading}
        </h2>
        <p className={styles.intro}>{cta.body}</p>
        <div className={styles.ctaButton}>
          <LandingButton link={cta.primary} kind="primary" />
        </div>
      </div>
    </section>
  );
}
